import angular from 'angular';

angular
  .module('cloudX')
  .controller('PlannedTasksDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    'dialogsSvc',
    '$element',
    'close',
    'schedule',
    '$http',
    'appUrls',
    '$timeout',
    plannedTasksDialogCtrl,
  ]);

function plannedTasksDialogCtrl(
  resourceFactorySvc,
  flySvc,
  dialogsSvc,
  $element,
  close,
  schedule,
  $http,
  appUrls,
  $timeout,
) {
  var vm = this;
  vm.lines = null;
  vm.schedule = schedule;
  vm.showHistory = false;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };

  $http.get(appUrls.tasks + '/Api/TaskSchedules/Lines/' + schedule.id).then(
    function({ data: { lines = [], errorCode = null } = {} }) {
      vm.lines = lines;
      vm.errorCode = errorCode;
    },
    function(error) {
      vm.lines = [];
      showError(error);
    },
  );

  vm.retrieveHistory = function() {
    vm.showHistory = true;
    $http.get(appUrls.tasks + '/Api/TaskSchedules/Lines/' + schedule.id + '?history=true').then(
      function({ data: { lines = [], errorCode = null } = {} }) {
        vm.lines = lines;
        vm.errorCode = errorCode;
      },
      function(error) {
        vm.lines = [];
        showError(error);
      },
    );
  };
  vm.openTaskDetail = function(line) {
    vm.taskDetail = { id: line.plannedTaskId };
  };
  vm.taskSaved = function(task) {
    $timeout(() => {
      if (task) {
        const line = vm.lines.find(x => x.plannedTaskId === task.id);
        if (line) {
          line.plannedTaskStatus = task.status;
          line.deadline = task.deadline;
        }
      }
      vm.closeTaskDetail();
    }, 0);
  };
  vm.closeTaskDetail = function() {
    $timeout(() => {
      vm.taskDetail = null;
    }, 0);
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
